import type { PricingList } from 'api/types/pricing.types';
import BottomSheet from 'components/molecules/BottomSheet';
import { SpinnerLoader } from 'components/molecules/Loaders';
import PricingPage from 'pages/pricing';
import React, { Suspense } from 'react';
import { Col, Container } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

const StyledContainer = styled(Container)`
  padding-bottom: 170px !important;
`;

interface PricingPageSheetProps {
  show: boolean;
  onClose?: () => any;
  serviceType?: PricingList.ServiceTypes;
}

const StyledCol = styled(Col)`
  margin-top: 1px;
`;

const PricingPageSheet: React.FC<PricingPageSheetProps> = ({ show, onClose, serviceType }) => {
  const theme = useTheme();

  return (
    <BottomSheet
      sheetId="bottomsheet-container-pricing-page"
      hideCloseButton
      show={show}
      onClose={onClose}
      maxHeight={theme.components.pricingSheet.maxHeight ?? '88%'}
      hideHeader
      hasNoSpacing
    >
      <StyledContainer className="pb-6 h-100">
        <StyledCol className="padding-start-0 padding-end-0">
          <Suspense fallback={<SpinnerLoader isDelayed />}>
            <PricingPage isBottomSheet serviceType={serviceType} onClose={onClose} />
          </Suspense>
        </StyledCol>
      </StyledContainer>
    </BottomSheet>
  );
};

export default PricingPageSheet;
